export default "__VITE_ASSET__DEHp2tN4__"